/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const GiftIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={16}
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="GiftIcon">
    <path
      d="M11.25.5A3 3 0 0 1 13.848 5h3.402v1.5h-1.5V14a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V6.5H.75V5h3.402A3 3 0 0 1 9 1.517 2.987 2.987 0 0 1 11.25.5Zm-3 6h-4.5v6.75h4.5V6.5Zm6 0h-4.5v6.75h4.5V6.5ZM6.75 2a1.5 1.5 0 0 0-.112 2.996L6.75 5h1.5V3.5a1.5 1.5 0 0 0-1.273-1.483l-.115-.013L6.75 2Zm4.5 0a1.5 1.5 0 0 0-1.496 1.388L9.75 3.5V5h1.5a1.5 1.5 0 0 0 1.496-1.387l.004-.113a1.5 1.5 0 0 0-1.5-1.5Z"
      fill="var(--highlight)"
      stroke="currentColor"
      strokeWidth={0.6}
    />
  </svg>
);

export default GiftIcon;
